import { useEffect, useRef } from "react";

function WatchStory() {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const video = videoRef.current;
        if (!video) return;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    const section = sectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full bg-[#1A1F2B] px-6 py-14"
    >
      <h2 className="text-3xl font-bold mb-6 text-center text-[#D9A05B]">
        Watch Our Story
      </h2>

      <div className="flex justify-center">
        <video
          ref={videoRef}
          src="/Images/video.mp4"
          muted
          playsInline
          controls
          preload="metadata"
          className="w-full max-w-2xl h-64 md:h-96 rounded-xl shadow-lg border-2 border-[#C9A86A]"
        />
      </div>
    </section>
  );
}
export default WatchStory;